module.exports = __webpack_public_path__ + "img/Loading.3e562346.gif";